import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { TfiDownload } from "react-icons/tfi";
import { MdError } from "react-icons/md";
import {
  ISO_Weld_log_Form_Table_Header,
  ImageBaseUrl,
  errorMessages,
} from "../../../utils/helperData";

const WeldInspectionTable = ({ inspectionDetaildata }) => {
  const [hoveredErrorField, setHoveredErrorField] = useState(null);
  const inspectionDetails = inspectionDetaildata?.form_info || [];

  console.log("inspectionDetaildata", inspectionDetaildata)
  const handleDownload = (documents) => {
    if (!documents || documents?.length === 0) {
      alert("No documents available to download.");
      return;
    }
    documents.forEach((doc) => {
      const link = document.createElement("a");
      link.href = `${ImageBaseUrl}${doc}`;
      link.download = doc;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  const isFieldInvalid = (detail, fieldKey) => {
    return detail[fieldKey] === false;
  };

  const renderValidatedCell = (detail, value, fieldKey, rowIndex) => {
    const isInvalid = isFieldInvalid(detail, fieldKey);

    return (
      <TableCell
        sx={{
          fontSize: "16px",
          color: isInvalid ? "red" : "#626262",
          position: "relative",
          padding: "16px",
        }}
      >
        {value || "-"}
        {isInvalid && (
          <MdError
            className="text-red-500 absolute top-3 right-1 transform -translate-y-1/2 cursor-pointer"
            onMouseEnter={() => setHoveredErrorField({ rowIndex, fieldKey })}
            onMouseLeave={() => setHoveredErrorField(null)}
          />
        )}
        {hoveredErrorField &&
          hoveredErrorField.rowIndex === rowIndex &&
          hoveredErrorField.fieldKey === fieldKey && (
            <div
              className="absolute z-10 bg-red-100 text-red-800 p-2 rounded-md shadow-lg text-xs"
              style={{
                top: "100%",
                left: 0,
                width: "max-content",
                maxWidth: "200px",
              }}
            >
              {errorMessages[fieldKey]}
            </div>
          )}
      </TableCell>
    );
  };

  return (
    <div className="flex justify-center overflow-auto">
      <TableContainer
        component={Paper}
        sx={{
          width: "100%",
          maxWidth: { xs: "600px", sm: "800px", md:"1100px", lg: "1270px" },
          height: "100%",
          overflow: "auto",
          border: "1px solid #ccc",
          borderRadius: "10px",
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {ISO_Weld_log_Form_Table_Header.map((header, index) => (
                <TableCell
                  key={index}
                  sx={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    color: "rgb(75 85 99)",
                    backgroundColor: "rgb(243 244 246)",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {inspectionDetails.map((detail, index) => (
              <TableRow
                hover
                key={index}
                sx={{
                  "&:hover": {
                    backgroundColor: "#e0e0e0",
                  },
                }}
              >
                <TableCell
                  sx={{
                    fontSize: "16px",
                    color: "#626262",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {detail?.loc_id?.name || "-"}
                </TableCell>
                {renderValidatedCell(
                  detail,
                  detail?.weld_no,
                  "is_valid_weld_no",
                  index
                )}
                <TableCell
                  sx={{
                    fontSize: "16px",
                    color: "#626262",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {/* {new Date(detail?.weld_date).toLocaleDateString()} */}
                  {detail?.weld_date
                    ? new Date(detail?.weld_date).toLocaleDateString("en-US", {
                        month: "2-digit", day: "2-digit", year: "numeric" })
                    : "-"}
                </TableCell>
                {renderValidatedCell(
                  detail,
                  detail?.welder_id,
                  "is_valid_welder_id",
                  index
                )}
                {renderValidatedCell(
                  detail,
                  detail.weld_size,
                  "is_valid_size",
                  index
                )}
                <TableCell
                  sx={{
                    fontSize: "16px",
                    color: "#626262",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {detail?.doc_id1?.name || "-"}
                </TableCell>
                {renderValidatedCell(
                  detail,
                  detail?.description,
                  "is_valid_description",
                  index
                )}
                {renderValidatedCell(
                  detail,
                  detail?.heat1_no,
                  "is_valid_heat1",
                  index
                )}
                {renderValidatedCell(
                  detail,
                  detail?.serial_no1,
                  "is_valid_serial1",
                  index
                )}
                <TableCell
                  sx={{
                    fontSize: "16px",
                    color: "#626262",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {detail?.doc_id2?.name || "-"}
                </TableCell>
                {renderValidatedCell(
                  detail,
                  detail?.description1,
                  "is_valid_description1",
                  index
                )}
                {renderValidatedCell(
                  detail,
                  detail?.heat2_no,
                  "is_valid_heat2",
                  index
                )}
                {renderValidatedCell(
                  detail,
                  detail?.serial_no2,
                  "is_valid_serial2",
                  index
                )}
                {renderValidatedCell(
                  detail,
                  detail?.machine_id,
                  "is_valid_machine_id",
                  index
                )}
                {renderValidatedCell(
                  detail,
                  detail?.gas_id,
                  "is_valid_gas_id",
                  index
                )}
                <TableCell
                  sx={{
                    fontSize: "16px",
                    color: "#626262",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {/* {new Date(detail?.ins_date).toLocaleDateString()} */}
                  {detail?.ins_date
                    ? new Date(detail?.ins_date).toLocaleDateString("en-US", {
                        month: "2-digit", day: "2-digit", year: "numeric",
                      })
                    : "-"}
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: "16px",
                    color: "#626262",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {detail?.inspector?.name || "-"}
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: "16px",
                    color: "#626262",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {detail?.ins_type || "-"}
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: "16px",
                    color: "#626262",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {detail?.ins_result || "-"}
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: "16px",
                    color: "#626262",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {detail?.weld_defect || "-"}
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: "16px",
                    color: "#626262",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {detail?.manual_weld || "-"}
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: "16px",
                    color: "#626262",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {detail.weld_info?.name || "-"}
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: "16px",
                    color: "#626262",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {detail?.other_ins_type || "-"}
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: "16px",
                    color: "#626262",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {detail?.comment || "-"}
                </TableCell>
                {detail?.document?.length > 0 && (
                  <TableCell sx={{ fontSize: "16px" }}>
                    <TfiDownload
                      className="h-7 w-7 cursor-pointer"
                      onClick={() => handleDownload(detail?.document)}
                    />
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default WeldInspectionTable;